import React from 'react';

import { ReactComponent as AllGoodIcon } from 'pages/Teachers/ClassroomInsights/assets/all-good-icon.svg';
import { ReactComponent as NeedsReviewIcon } from 'pages/Teachers/ClassroomInsights/assets/error-icon.svg';
import { ReactComponent as LoadingIcon } from 'pages/Teachers/ClassroomInsights/assets/loading-icon.svg';
import {
  GENERAL_CONCEPTUAL_UNDERSTANDING,
  SIGNIFICANT_ERRORS_IN_WORK,
  UNABLE_TO_DIAGNOSE,
  WORK_IS_COMPLETE_AND_CORRECT
} from 'pages/Teachers/Insights/constants';

export const MASTERY_LEVELS = {
  CELEBRATE: 'Celebrate',
  SUPPORT: 'Support',
  INTERVENE: 'Intervene',
  NEEDS_REVIEW: 'Reupload needed',
  NEED_UPLOAD: 'Need upload',
  LOADING: 'Loading',
  PENDING_UPLOAD: 'Pending Upload'
};

export const MASTERY_LEVEL_TO_LABEL_MAPPER = {
  [WORK_IS_COMPLETE_AND_CORRECT]: MASTERY_LEVELS.CELEBRATE,
  [GENERAL_CONCEPTUAL_UNDERSTANDING]: MASTERY_LEVELS.SUPPORT,
  [SIGNIFICANT_ERRORS_IN_WORK]: MASTERY_LEVELS.INTERVENE,
  [UNABLE_TO_DIAGNOSE]: MASTERY_LEVELS.NEEDS_REVIEW,
  Loading: MASTERY_LEVELS.LOADING,
  'Needs Review': MASTERY_LEVELS.NEEDS_REVIEW,
  'Need upload': MASTERY_LEVELS.PENDING_UPLOAD
};

export const LEVEL_LABEL_TO_MASTERY_MAPPER = {
  [MASTERY_LEVELS.CELEBRATE]: WORK_IS_COMPLETE_AND_CORRECT,
  [MASTERY_LEVELS.SUPPORT]: GENERAL_CONCEPTUAL_UNDERSTANDING,
  [MASTERY_LEVELS.INTERVENE]: SIGNIFICANT_ERRORS_IN_WORK,
  [MASTERY_LEVELS.NEEDS_REVIEW]: UNABLE_TO_DIAGNOSE
};

export const MASTERY_LEVEL_TO_LABEL_MAPPER_SELECT = {
  [WORK_IS_COMPLETE_AND_CORRECT]: MASTERY_LEVELS.CELEBRATE,
  [GENERAL_CONCEPTUAL_UNDERSTANDING]: MASTERY_LEVELS.SUPPORT,
  [SIGNIFICANT_ERRORS_IN_WORK]: MASTERY_LEVELS.INTERVENE
};

export const NUMBER_VALUE_TYPES = ['number', 'custom'];

export const GRADES_MAPPER = {
  checkbox: [
    { value: 1, label: 'Correct' },
    { value: 0, label: 'Incorrect' }
  ],
  check_grade: [
    {
      value: 1,
      label: 'Check Plus'
    },
    {
      value: 0,
      label: 'Check'
    },
    {
      value: -1,
      label: 'Check Minus'
    }
  ],
  rubric_zero_four: [
    { value: 0, label: '0' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' }
  ],
  rubric_a_to_f: [
    { value: 4, label: 'A' },
    { value: 3, label: 'B' },
    { value: 2, label: 'C' },
    { value: 1, label: 'D' },
    { value: 0, label: 'F' }
  ],
  performance: [
    { value: 0, label: 'Beginning' },
    { value: 1, label: 'Approaching' },
    { value: 2, label: 'Proficient' },
    { value: 3, label: 'Excelling' }
  ]
};

export const BACKGROUND_COLOR_MAPPER = {
  [MASTERY_LEVELS.CELEBRATE]: {
    borderColor: '#90CF8F',
    backgroundColor: '#E2F6E2',
    color: '#3A7339'
  },
  [MASTERY_LEVELS.SUPPORT]: {
    color: '#A16C07',
    backgroundColor: '#FFF8EC',
    borderColor: '#F3DAA8'
  },
  [MASTERY_LEVELS.INTERVENE]: {
    color: '#C32E3F',
    backgroundColor: '#FAECF0',
    borderColor: '#F4C3CB'
  },
  [MASTERY_LEVELS.NEEDS_REVIEW]: {
    borderColor: '#AAAAB9',
    backgroundColor: '#EEEEF3',
    color: '#6E6E84'
  },
  [MASTERY_LEVELS.PENDING_UPLOAD]: {
    borderColor: '#CCCCD9',
    backgroundColor: '#FBFBFF',
    color: '#6E6E84'
  }
};

export const MASTERY_TEXT_MAPPER = {
  [MASTERY_LEVELS.CELEBRATE]: 'Student is meeting or exceeding the standard',
  [MASTERY_LEVELS.SUPPORT]: 'Student is close to meeting the standard',
  [MASTERY_LEVELS.INTERVENE]:
    'Student needs additional support on this standard',
  [MASTERY_LEVELS.NEEDS_REVIEW]: '',
  [MASTERY_LEVELS.PENDING_UPLOAD]: ''
};

export const STATUS_ICON_MAPPER = {
  [MASTERY_LEVELS.CELEBRATE]: <AllGoodIcon />,
  [MASTERY_LEVELS.SUPPORT]: <AllGoodIcon />,
  [MASTERY_LEVELS.INTERVENE]: <AllGoodIcon />,
  [MASTERY_LEVELS.NEEDS_REVIEW]: <NeedsReviewIcon />,
  [MASTERY_LEVELS.PENDING_UPLOAD]: <LoadingIcon />
};

export const STATUS_TEXT_MAPPER = {
  [MASTERY_LEVELS.CELEBRATE]: 'Student Work uploaded successfully',
  [MASTERY_LEVELS.SUPPORT]: 'Student Work uploaded successfully',
  [MASTERY_LEVELS.INTERVENE]: 'Student Work uploaded successfully',
  [MASTERY_LEVELS.NEEDS_REVIEW]: 'Student Work upload failed',
  [MASTERY_LEVELS.PENDING_UPLOAD]: "Student hasn't uploaded their work yet"
};
